import { render } from "./AddonSEO.vue?vue&type=template&id=74d1a606&scoped=true"
import script from "./AddonSEO.vue?vue&type=script&lang=js"
export * from "./AddonSEO.vue?vue&type=script&lang=js"

import "./AddonSEO.vue?vue&type=style&index=0&id=74d1a606&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d1a606"]])

export default __exports__